import {
  REQUEST_SAVED_PRINTERS,
  RECEIVE_SAVED_PRINTERS,
  REQUEST_PRINTER_SEARCH_RESULTS,
  RECEIVE_PRINTER_SEARCH_RESULTS,
  UPDATE_SAVED_PRINTER,
  REMOVE_SAVED_PRINTER
} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

export default function yourPrintersReducer(state = initialState, action) {
  let newState = objectAssign({}, state),
    savedPrinters = objectAssign([], newState.savedPrinters);
  switch (action.type) {
    case REQUEST_SAVED_PRINTERS:
      return objectAssign({}, state, {
        isFetching: true
      });

    case RECEIVE_SAVED_PRINTERS:
      return objectAssign({}, state, {
        customerNumber: action.customerNumber,
        savedPrinters: action.items,
        isFetching: false
      });

    case REQUEST_PRINTER_SEARCH_RESULTS:
      return objectAssign({}, state, {
        isFetchingSearchResults: true
      });

    case RECEIVE_PRINTER_SEARCH_RESULTS:
      return objectAssign({}, state, {
        printerSearchResults: action.items,
        isFetchingSearchResults: false
      });

    case UPDATE_SAVED_PRINTER:
      savedPrinters = savedPrinters.map(item => {
        if (item.id === action.id) {
          return objectAssign({}, item, { name: action.name });
        }
        return item;
      });

      return objectAssign({}, state, {
        savedPrinters
      });

    case REMOVE_SAVED_PRINTER:
      savedPrinters = savedPrinters.filter(item => item.id !== action.id);

      return objectAssign({}, state, {
        savedPrinters
      });

    default:
      return state;
  }
}
